import React from "react";
import {connect} from "react-redux";
import {IStore} from "../../../store/reducers";
import actionTypes from "../../../store/actionTypes";
import {LatLngTuple} from "leaflet";
import {Map, TileLayer, Polygon, ZoomControl, Marker} from "react-leaflet";
import {IMapas, INewParcelaSection, INotificacion} from "../../../types";
import {readFileAsync} from "../../../tools/readFile";
import {getCenterZoom} from "../../../tools/getCenterZoom";
import {
    Typography,
    Button,
    InputLabel,
    Select,
    MenuItem,
    FormControl,
    TextField,
    CircularProgress
} from "@material-ui/core";
import {NavigateBefore, Search} from "@material-ui/icons";
import Basura from "../../../icons/PNGs/basura.png";
import Agregar from "../../../icons/PNGs/agregar.png";
import Editar from "../../../icons/PNGs/editar.png";
import FixedPoint from "../../../icons/PNGs/fixed_point.png";
import CreatePoint from "../../../icons/PNGs/create_point.png";
import EditablePoint from "../../../icons/PNGs/editable_point.png";
import DeletePoint from "../../../icons/PNGs/delete_point.png";
import L from "leaflet";
import axios from "axios";
import config from "../../../config.json";
import {userService} from "../../../services/UserService";
import * as THREE from "three";
import AyudaParcela from "./AyudaParcela";

const simplepolygon = require('simplepolygon')
const pointInPolygon = require('point-in-polygon');
const geolib = require('geolib');
const utmObj = require('utm-latlng');
const UTM = new utmObj()

const texts = require('../../../texts/crearparcela.json');


const fixed_icon = new L.Icon({
    iconUrl: FixedPoint,
    iconRetinaUrl: FixedPoint,
    iconSize: [25, 25]
})

const create_icon = new L.Icon({
    iconUrl: CreatePoint,
    iconRetinaUrl: CreatePoint,
    iconSize: [25, 25]
})

const editable_icon = new L.Icon({
    iconUrl: EditablePoint,
    iconRetinaUrl: EditablePoint,
    iconSize: [25, 25]
})

const delete_icon = new L.Icon({
    iconUrl: DeletePoint,
    iconRetinaUrl: DeletePoint,
    iconSize: [25, 25]
})

const colors = {
    "fixed": "#448eff",
    "create": "#ffffff",
    "edit": "#dcc32d",
    "delete": "#bf3636"
}


interface IProps {
    mapa: IMapas
    zoom: number
    center: LatLngTuple
    polygon: LatLngTuple[]
    limiteHa: number
    level: number
    idioma: string
    notify(notification: INotificacion): void
    setMapa(mapa: IMapas): void
    setZoom(zoom: number): void
    setCenter(center: LatLngTuple): void
    setPolygon(polygon: LatLngTuple[]): void
    setEditando(editando: boolean): void
    setCrearParcelaSection(seccion: INewParcelaSection): void
    setHusoUTM(huso: number): void
    setBandeUTM(banda: string): void
}

interface IState {
    hover: string
    clicked: string
    cargado: boolean
    superficie: number|string
    // spain_geom: Record<string, LatLngTuple[]>
    text: Record<string, string>
    refs: Record<string, Record<string, Record<string, string>>>
    comunidad: string
    provincia: string
    municipio: string
    poligono: number | null
    parcela: number | null
    buscando: boolean
}

const urls = {
    satelite: 'https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}',
    carreteras: 'https://mt1.google.com/vt/lyrs=r&x={x}&y={y}&z={z}'
}

class Ubicacion extends React.Component<IProps, IState> {
    state: IState = {
        hover: '',
        clicked: '',
        cargado: true,
        superficie: 0,
        // spain_geom: {} as Record<string, LatLngTuple[]>,
        text: texts[this.props.idioma],
        refs: {},
        comunidad: "",
        provincia: "",
        municipio: "",
        poligono: null,
        parcela: null,
        buscando: false
    }

    componentDidMount() {

        // axios.get(
        //     config.url+`/static/spain_complete.json`,
        //     {auth: {
        //             username: `${userService.getUser()}`,
        //             password: `${userService.getPass()}`
        //         }})
        //     .then((res) => {
        //         this.setState({spain_geom: res.data})
        //     })
        //     .catch(() => {
        //         this.props.notify({message: this.state.text["1"], variant: 'error'})
        //     })

        axios.get(
            config.url+`/static/codigos_catastro.json`,
            {auth: {
                    username: `${userService.getUser()}`,
                    password: `${userService.getPass()}`
                }})
            .then((res) => {
                this.setState({refs: res.data})
            })
            .catch(() => {
                this.props.notify({message: this.state.text["1"], variant: 'error'})
            })

        if (this.props.polygon.length === 0) {
            this.setState({superficie: 0})
        } else {
            this.setState({superficie: this.getAreaSurface()})
        }
    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (this.props.idioma !== nextProps.idioma) {
            this.setState({
                text: texts[nextProps.idioma]
            })
        }

        if (this.props.polygon !== nextProps.polygon) {
            if (nextProps.polygon.length === 0) {
                this.setState({superficie: 0})
            } else {
                this.setState({superficie: this.getAreaSurface()})
                this.props.setHusoUTM(UTM.convertLatLngToUtm(nextProps.polygon[0][0], nextProps.polygon[0][1], 1).ZoneNumber)
                this.props.setBandeUTM(UTM.convertLatLngToUtm(nextProps.polygon[0][0], nextProps.polygon[0][1], 1).ZoneLetter)
            }
        }
        return true
    }


    // pointInSpain = (point: LatLngTuple): boolean => {
    //     for (let name of Object.keys(this.state.spain_geom)) {
    //         if (pointInPolygon([point[0], point[1]], this.state.spain_geom[name])) return true
    //     }
    //     return false
    // }


    generatesCartesiansystem = () => {
        let coords: number[][] = []
        if (this.props.polygon.length === 0) return coords
        coords.push([0,0])
        if (this.props.polygon.length === 1) return coords

        let a = 0
        let point = 0
        for (let i = 1; i < this.props.polygon.length; i++) {
            let d = geolib.getPreciseDistance(
                {latitude: this.props.polygon[0][0], longitude: this.props.polygon[0][1]},
                {latitude: this.props.polygon[i][0], longitude: this.props.polygon[i][1]},
                0.01
            )
            if (d > a) {
                a = d
                point = i
            }
        }
        let b = 0
        let c = 0
        let theta = 0
        for (let i = 1; i < this.props.polygon.length; i++) {
            if (i === point) {
                coords.push([a, 0])
            } else {
                b = geolib.getPreciseDistance(
                    {latitude: this.props.polygon[0][0], longitude: this.props.polygon[0][1]},
                    {latitude: this.props.polygon[i][0], longitude: this.props.polygon[i][1]},
                    0.01
                )
                c = geolib.getPreciseDistance(
                    {latitude: this.props.polygon[point][0], longitude: this.props.polygon[point][1]},
                    {latitude: this.props.polygon[i][0], longitude: this.props.polygon[i][1]},
                    0.01
                )
                if (i < point) {
                    theta = Math.acos((a**2 + b**2 - c**2)/(2*a*b))
                } else {
                    theta = -Math.acos((a**2 + b**2 - c**2)/(2*a*b))
                }
                coords.push([
                    b*Math.cos(theta),
                    b*Math.sin(theta)
                ])
            }
        }
        return coords
    }

    isSimpleSurface = (): boolean => {
        if (this.props.polygon.length < 4) return true
        let areaPoints = []
        for (let point of this.props.polygon) {
            areaPoints.push([point[0]*1000, point[1]*1000])
        }
        areaPoints.push([this.props.polygon[0][0]*1000, this.props.polygon[0][1]*1000])

        if (areaPoints[areaPoints.length-1][0] === areaPoints[areaPoints.length-2][0] &&
            areaPoints[areaPoints.length-1][1] === areaPoints[areaPoints.length-2][1]
        ) areaPoints.pop()

        if (areaPoints[areaPoints.length-1][0] === areaPoints[0][0] &&
            areaPoints[areaPoints.length-1][1] === areaPoints[0][1]
        ) areaPoints.pop()

        let points: LatLngTuple[] = []
        for (let point of areaPoints) {
            points.push([point[0]/1000, point[1]/1000])
        }

        if (this.props.polygon.length !== points.length) this.props.setPolygon(points)

        let poly = {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [areaPoints]
            }
        };

        let result = simplepolygon(poly)
        return result.features.length === 1;
    }


    getAreaSurface = (): number|string => {
        if (this.props.polygon.length < 3) return 0

        if (!this.isSimpleSurface()) return "-"

        const c = this.generatesCartesiansystem()
        let coords = []
        for (let coord of c) {
            coords.push({x: coord[1], y: coord[0]})
        }

        const area = THREE.ShapeUtils.area(coords)
        return Math.sign(area)*Math.round(area/100)/100
    }


    handleVista = () => {
        if (this.props.mapa === 'satelite') this.props.setMapa('carreteras')
        if (this.props.mapa === 'carreteras') this.props.setMapa('satelite')
        return
    }

    handleEdited = (e: any) => {
        try {
            const polygon: LatLngTuple[] = []
            const key = Object.keys(e.layers._layers)[0]
            for (const element of e.layers._layers[key].getLatLngs()[0]) {
                polygon.push([element.lat, element.lng])
            }
            polygon.push(polygon[0])
            this.props.setPolygon(polygon)
            this.props.setEditando(false)
        } catch (e) {
            this.props.setEditando(false)
            return
        }
    }

    onDragOver = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
    }

    onDrop = async (e: React.DragEvent<HTMLDivElement>) => {
        if (this.props.polygon.length > 0) {
            this.setState({cargado: false})
            this.props.setPolygon([] as LatLngTuple[])
            setTimeout(() => this.setState({cargado: true}), 1)
        }
        e.preventDefault();
        try{
            const files = e!.dataTransfer.files;
            if (files.length > 1) {
                this.props.notify({message: this.state.text["24"], variant: 'warning'})
                return
            }
            const file = files[0]
            if (!file.name.toLowerCase().endsWith('.kml')) {
                this.props.notify({message: this.state.text["25"], variant: 'warning'})
                return
            }

            const resultData = await readFileAsync(file, true);
            const kml = new DOMParser().parseFromString(resultData as string, "text/xml");
            const c = kml.getElementsByTagName('coordinates')
            const text = c[0].textContent as string
            const polygon: LatLngTuple[] = []
            for (const row of text.split(" ")) {
                const lat = parseFloat(row.split(',')[1])
                const lng = parseFloat(row.split(',')[0])
                polygon.push([lat, lng])
            }
            if (polygon.length < 4 ||
                polygon[0][0] !== polygon[polygon.length-1][0] ||
                polygon[0][1] !== polygon[polygon.length-1][1]) {
                this.props.notify({message: this.state.text["26"], variant: 'error'})
                return
            }

            const centerZoom = getCenterZoom(polygon)

            this.props.setCenter(centerZoom.center)
            this.props.setPolygon(polygon)

        } catch (e) {
            this.props.notify({message: this.state.text["26"], variant: 'error'})
        }
    }

    setColor = () => {
        if (!this.isSimpleSurface()) return colors["delete"]
        switch (this.state.clicked) {
            case "crear":
                return colors["create"]
            case "editar":
                return colors["edit"]
            case "borrar":
                return colors["delete"]
            default:
                return colors["fixed"]
        }
    }

    setIcon = () => {
        if (!this.isSimpleSurface()) return delete_icon
        switch (this.state.clicked) {
            case "crear":
                return create_icon
            case "editar":
                return editable_icon
            case "borrar":
                return delete_icon
            default:
                return fixed_icon
        }
    }

    setCursor = () => {
        switch (this.state.clicked) {
            case "crear":
                return 'cell'
            case "editar":
                return "auto"
            case "borrar":
                return 'auto'
            default:
                return "pointer"
        }
    }

    handleClick = () => {
        this.props.setCrearParcelaSection('Sectores')
    }

    handleSearch = () => {

        if (this.state.poligono === null) {
            this.props.notify({message: this.state.text["69"], variant: 'error'})
            return
        }
        if (this.state.parcela === null) {
            this.props.notify({message: this.state.text["70"], variant: 'error'})
            return
        }
        if (this.state.poligono < 0) {
            this.props.notify({message: this.state.text["69"], variant: 'error'})
            return
        }
        if (this.state.parcela < 0) {
            this.props.notify({message: this.state.text["70"], variant: 'error'})
            return
        }

        let poligono = ''
        if (this.state.poligono.toString().length === 1) {
            poligono = '00'+this.state.poligono.toString()
        } else if (this.state.poligono.toString().length === 2) {
            poligono = '0'+this.state.poligono.toString()
        } else if (this.state.poligono.toString().length === 3) {
            poligono = this.state.poligono.toString()
        } else {
            this.props.notify({message: this.state.text["69"], variant: 'error'})
            return
        }


        let parcela = ''
        if (this.state.parcela.toString().length === 1) {
            parcela = '0000'+this.state.parcela.toString()
        } else if (this.state.parcela.toString().length === 2) {
            parcela = '000'+this.state.parcela.toString()
        } else if (this.state.parcela.toString().length === 3) {
            parcela = '00'+this.state.parcela.toString()
        } else if (this.state.parcela.toString().length === 4) {
            parcela = '0'+this.state.parcela.toString()
        } else if (this.state.parcela.toString().length === 5) {
            parcela = this.state.parcela.toString()
        } else {
            this.props.notify({message: this.state.text["70"], variant: 'error'})
            return
        }

        let refCatastral: string = this.state.refs[this.state.comunidad][this.state.provincia][this.state.municipio]+"A"+poligono+parcela

        this.setState({buscando: true})

        const url: string = config.url+`/catastro/coords?ref=${refCatastral}`
        axios.get(
            url,
            {auth: {
                    username: `${userService.getUser()}`,
                    password: `${userService.getPass()}`
                }})
            .then((res) => {

                const polygon: LatLngTuple[] = []
                for (const row of res.data.coords) {
                    polygon.push([row[0], row[1]])
                }
                const centerZoom = getCenterZoom(polygon)
                this.props.setCenter(centerZoom.center)
                this.props.setPolygon(polygon)

                this.setState({buscando: false})
            })
            .catch((error) => {
                if (error.response.status === 404) {
                    this.props.notify({message: 'No se ha encontrado ninguna parcela con esta referencia, por favor, dibújela', variant: 'warning'})
                } else if (error.response.status === 403){
                    this.props.notify({message: 'El poligono de SigPac tiene demasiados puntos, porfavor, dibuje el polígono', variant: 'warning'})
                } else {
                    this.props.notify({message: 'Error interno', variant: 'error'})
                }
                this.setState({buscando: false})
            })
    }

    render () {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    height: '100%',
                }}
            >
                <AyudaParcela/>
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        width: '25%',
                        height: '100%',
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            height: '90%',
                            width: '85%',
                            alignItems: "center",
                            overflowY: "auto"
                        }}
                    >

                        <Typography
                            style={{
                                fontSize: 38,
                                fontWeight: "bold",
                                color: "#4C494B",
                                fontFamily: "Poppins",
                                textAlign: "center",
                                marginTop: 40,
                                marginBottom: 20
                            }}
                        >
                            {this.state.text["27"]}
                        </Typography>


                        <Button
                            color={"secondary"}
                            variant={"contained"}
                            style={{
                                width: "95%",
                                height: "fit-content",
                                marginBottom: 20,
                                textTransform: "none"
                            }}
                            onClick={() => this.props.setCrearParcelaSection('AyudaParcela')}
                        >
                            <Typography
                                style={{
                                    color: "#4C494B",
                                    fontFamily: "Poppins",
                                    fontSize: 18,
                                    fontWeight: "bold",
                                }}
                            >
                                {this.state.text["78"]}
                            </Typography>
                        </Button>


                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                width: '100%',
                                alignItems: "center",
                                justifyContent: "space-between"
                            }}
                        >
                            <div/>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    width: '30%'
                                }}
                            >
                                <Typography
                                    style={{
                                        fontSize:20,
                                        fontWeight: this.state.clicked === "crear"? "bold" : "normal",
                                        color: "#4C494B",
                                        fontFamily: "Poppins",
                                        textAlign: "center",
                                        height: 30
                                    }}
                                >
                                    {this.state.text["28"]}
                                </Typography>
                                <Button
                                    variant={"contained"}
                                    style={{
                                        width: window.innerWidth*0.25*0.8*0.3,
                                        height: window.innerWidth*0.25*0.8*0.3,
                                        borderRadius: 20,
                                        backgroundColor: this.state.clicked === "crear"? "#eee" : "white",
                                    }}
                                    onClick={() => {
                                        if (this.state.clicked === "crear") {
                                            this.setState({clicked: ""})
                                        } else {
                                            this.setState({clicked: "crear"})
                                        }
                                    }}
                                >
                                    <img
                                        style={{
                                            width: window.innerWidth*0.25*0.8*0.3,
                                            height: window.innerWidth*0.25*0.8*0.3
                                        }}
                                        src={Agregar}

                                        alt="agregar img"
                                    />
                                </Button>

                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    width: '30%'
                                }}
                            >
                                <Typography
                                    style={{
                                        fontSize:20,
                                        fontWeight: this.state.clicked === "editar"? "bold" : "normal",
                                        color: "#4C494B",
                                        fontFamily: "Poppins",
                                        textAlign: "center",
                                        height: 30
                                    }}
                                >
                                    {this.state.text["29"]}
                                </Typography>
                                <Button
                                    variant={"contained"}
                                    style={{
                                        borderRadius: 20,
                                        backgroundColor: this.state.clicked === "editar"? "#eee" : "white",
                                        width: window.innerWidth*0.25*0.8*0.3,
                                        height: window.innerWidth*0.25*0.8*0.3
                                    }}
                                    onClick={() => {
                                        if (this.state.clicked === "editar") {
                                            this.setState({clicked: ""})
                                        } else {
                                            this.setState({clicked: "editar"})
                                        }
                                    }}
                                >
                                    <img
                                        style={{
                                            width: window.innerWidth*0.25*0.8*0.3,
                                            height: window.innerWidth*0.25*0.8*0.3
                                        }}
                                        src={Editar}

                                        alt="editar img"
                                    />
                                </Button>

                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    width: '30%'
                                }}
                            >
                                <Typography
                                    style={{
                                        fontSize:20,
                                        fontWeight: this.state.clicked === "borrar"? "bold" : "normal",
                                        color: "#4C494B",
                                        fontFamily: "Poppins",
                                        textAlign: "center",
                                        height: 30
                                    }}
                                >
                                    {this.state.text["30"]}
                                </Typography>
                                <Button
                                    variant={"contained"}
                                    style={{
                                        borderRadius: 20,
                                        backgroundColor: this.state.clicked === "borrar"? "#eee" : "white",
                                        width: window.innerWidth*0.25*0.8*0.3,
                                        height: window.innerWidth*0.25*0.8*0.3
                                    }}
                                    onClick={() => {
                                        if (this.state.clicked === "borrar") {
                                            this.setState({clicked: ""})
                                        } else {
                                            this.setState({clicked: "borrar"})
                                        }
                                    }}
                                >
                                    <img
                                        style={{
                                            width: window.innerWidth*0.25*0.8*0.3,
                                            height: window.innerWidth*0.25*0.8*0.3
                                        }}
                                        src={Basura}

                                        alt="borar img"
                                    />
                                </Button>
                            </div>
                            <div/>

                        </div>




                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                width: "95%",
                                height: "fit-content",
                                marginTop: 20
                            }}
                        >
                            <Typography
                                style={{
                                    fontSize: 24,
                                    color: "#4C494B",
                                    fontFamily: "Poppins",
                                    textAlign: "center",
                                    fontWeight: "bold"
                                }}
                            >
                                {this.state.text["62"]}
                            </Typography>

                            <FormControl
                                style={{
                                    width: '100%'
                                }}
                            >
                                <InputLabel style={{fontSize: 18, fontFamily: "Poppins"}}>{this.state.text["63"]}</InputLabel>
                                <Select
                                    inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                                    value={this.state.comunidad}
                                    onChange={e => {
                                        this.setState({
                                            comunidad: e.target.value as string,
                                            provincia: "",
                                            municipio: ""
                                        })
                                    }}
                                >
                                    {Object.keys(this.state.refs).map(el =>{
                                        return <MenuItem key={el} value={el}>
                                            <Typography style={{fontSize: 18, fontFamily: "Poppins"}}>
                                                {el}
                                            </Typography>
                                        </MenuItem>
                                    })}
                                </Select>
                            </FormControl>

                            <FormControl
                                style={{
                                    width: '100%'
                                }}
                            >
                                <InputLabel style={{fontSize: 18, fontFamily: "Poppins"}}>{this.state.text["64"]}</InputLabel>
                                <Select
                                    inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                                    value={this.state.provincia}
                                    onChange={e => {
                                        this.setState({
                                            provincia: e.target.value as string,
                                            municipio: ""
                                        })
                                    }}
                                >
                                    {this.state.comunidad.length === 0?
                                        null
                                        :
                                        Object.keys(this.state.refs[this.state.comunidad]).map(el =>{
                                            return <MenuItem key={el} value={el}>
                                                <Typography style={{fontSize: 18, fontFamily: "Poppins"}}>
                                                    {el}
                                                </Typography>
                                            </MenuItem>
                                        })
                                    }

                                </Select>
                            </FormControl>

                            <FormControl
                                style={{
                                    width: '100%'
                                }}
                            >
                                <InputLabel style={{fontSize: 18, fontFamily: "Poppins"}}>{this.state.text["65"]}</InputLabel>
                                <Select
                                    inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                                    value={this.state.municipio}
                                    onChange={e => {
                                        this.setState({
                                            municipio: e.target.value as string
                                        })
                                    }}
                                >
                                    {this.state.provincia.length === 0 || this.state.comunidad.length === 0?
                                        null
                                        :
                                        Object.keys(this.state.refs[this.state.comunidad][this.state.provincia]).map(el =>{
                                            return <MenuItem key={el} value={el}>
                                                <Typography style={{fontSize: 18, fontFamily: "Poppins"}}>
                                                    {el+" ("+this.state.refs[this.state.comunidad][this.state.provincia][el]+")"}
                                                </Typography>
                                            </MenuItem>
                                        })
                                    }

                                </Select>
                            </FormControl>

                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    width: '100%',
                                    alignItems: "center"
                                }}
                            >
                                <TextField
                                    style={{
                                        width: "100%"
                                    }}
                                    type="number"
                                    label={this.state.text["66"]}
                                    value={this.state.poligono}
                                    onChange={e => {
                                        if (isNaN(parseFloat(e.target.value))) {
                                            this.setState({poligono: 0})
                                        } else {
                                            this.setState({poligono: parseInt(e.target.value)})
                                        }
                                    }}
                                    inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                                    InputLabelProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                                />
                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    width: '100%',
                                    alignItems: "center"
                                }}
                            >
                                <TextField
                                    style={{
                                        width: "100%"
                                    }}
                                    type="number"
                                    label={this.state.text["67"]}
                                    value={this.state.parcela}
                                    onChange={e => {
                                        if (isNaN(parseFloat(e.target.value))) {
                                            this.setState({parcela: 0})
                                        } else {
                                            this.setState({parcela: parseInt(e.target.value)})
                                        }
                                    }}
                                    inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                                    InputLabelProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                                />
                            </div>

                            <Button
                                variant={"contained"}
                                color={"primary"}
                                disabled={this.state.comunidad.length === 0 || this.state.provincia.length === 0 || this.state.municipio.length === 0 || this.state.poligono === null || this.state.parcela === null}
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    width: "100%",
                                    marginTop: 5
                                }}
                                onClick={() => this.handleSearch()}
                            >
                                {this.state.buscando?
                                    <CircularProgress
                                        style={{
                                            color: "#b42333",
                                            width: 30,
                                            height: 30
                                        }}
                                    />
                                    :
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center"
                                        }}
                                    >
                                        <Typography
                                            style={{
                                                fontSize:20,
                                                color: "#4C494B",
                                                fontFamily: "Poppins",
                                                textTransform: "none"
                                            }}
                                        >
                                            {this.state.text["68"]}
                                        </Typography>
                                        <Search style={{color: "#4C494B", marginLeft: 10}}/>
                                    </div>
                                }
                            </Button>
                        </div>



                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "95%",
                                marginTop: 10
                            }}
                        >
                            <Typography
                                style={{
                                    fontSize:16,
                                    color: "#4C494B",
                                    fontFamily: "Poppins"
                                }}
                            >
                                {this.state.text["34"]}
                            </Typography>
                        </div>


                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "95%",
                                marginTop: 30
                            }}
                        >

                            {this.props.level < 5 &&
                                <Typography
                                    style={{
                                        fontSize: 18,
                                        color: "#4C494B",
                                        fontFamily: "Poppins"
                                    }}
                                >
                                    <b>{this.state.text["31"]}  </b>: {Math.round(this.props.limiteHa*100)/100} ha
                                </Typography>
                            }

                            {this.props.level === 5 || this.props.limiteHa > 1000 &&
                                <Typography
                                    style={{
                                        fontSize: 18,
                                        color: "#4C494B",
                                        fontFamily: "Poppins",
                                        marginTop: 10
                                    }}
                                >
                                    <b>{this.state.text["32"]}</b>: {1000} ha
                                </Typography>
                            }

                            <Typography
                                style={{
                                    fontSize:18,
                                    color: "#4C494B",
                                    fontFamily: "Poppins",
                                    marginTop: 10
                                }}
                            >
                                <b>{this.state.text["33"]}</b>: {this.getAreaSurface()} ha
                            </Typography>

                        </div>

                    </div>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            height: '10%',
                            width: '80%',
                            alignItems: "center",
                            justifyContent: "space-between"
                        }}
                    >
                        <Button
                            style={{
                                height: "fit-content",
                                borderRadius: 10
                            }}
                            onClick={() => this.props.setCrearParcelaSection("Caracterización")}
                        >
                            <NavigateBefore
                                style={{
                                    height: 30,
                                    width: 30
                                }}
                            />
                            <Typography
                                style={{
                                    textTransform: "none",
                                    fontSize: 20,
                                    fontWeight: "bold",
                                    marginLeft: 10,
                                    textDecoration: 'underline',
                                    fontFamily: "Poppins"
                                }}
                            >
                                {this.state.text["35"]}
                            </Typography>
                        </Button>

                        <Button
                            style={{
                                height: "fit-content",
                                borderRadius: 10
                            }}
                            variant={"contained"}
                            color={"primary"}
                            disabled={this.props.polygon.length === 0 || !this.isSimpleSurface()}
                            onClick={() => this.handleClick()}
                        >
                            <Typography
                                style={{
                                    textTransform: "none",
                                    fontSize: 20,
                                    fontWeight: "bold",
                                    marginLeft: 10,
                                    fontFamily: "Poppins"
                                }}
                            >
                                {this.state.text["36"]}
                            </Typography>
                        </Button>

                    </div>



                </div>

                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: '75%',
                        height: '100%',
                    }}
                    onDragOver={(e) => this.onDragOver(e)}
                    onDrop={(e) => this.onDrop(e)}
                >
                    <Map
                        center={this.props.center}
                        zoom={this.props.zoom}
                        maxZoom={20}
                        style={{
                            width: '100%',
                            height: '100%',
                            zIndex: 1,
                            cursor: this.setCursor()
                        }}
                        onmoveend={(e) => {
                            this.props.setZoom(e.target.getZoom())
                            this.props.setCenter([e.target.getCenter().lat,e.target.getCenter().lng])
                        }}
                        zoomControl={false}
                        onclick={(e) => {
                            if (this.state.clicked === 'crear') {
                                this.setState({cargado: false})

                                // if (this.pointInSpain([e.latlng.lat, e.latlng.lng] as LatLngTuple)) {
                                //
                                //     let poligon = [...this.props.polygon] as LatLngTuple[]
                                //     poligon.push([e.latlng.lat, e.latlng.lng] as LatLngTuple)
                                //     if (geolib.getAreaOfPolygon(poligon) / 10000 > 1000) {
                                //         this.props.notify({
                                //             message: this.state.text["37"],
                                //             variant: 'error'
                                //         })
                                //     } else {
                                //         if (geolib.getAreaOfPolygon(poligon) / 10000 > this.props.limiteHa) {
                                //             this.props.notify({
                                //                 message: `${this.state.text["38"]} (${Math.round(this.props.limiteHa * 100) / 100} Ha)`,
                                //                 variant: 'error'
                                //             })
                                //         } else {
                                //             this.props.setPolygon(poligon)
                                //
                                //         }
                                //     }
                                // } else {
                                //     this.props.notify({message: `${this.state.text["39"]}`, variant: 'error'})
                                // }

                                let poligon = [...this.props.polygon] as LatLngTuple[]
                                poligon.push([e.latlng.lat, e.latlng.lng] as LatLngTuple)
                                if (geolib.getAreaOfPolygon(poligon) / 10000 > 1000) {
                                    this.props.notify({
                                        message: this.state.text["37"],
                                        variant: 'error'
                                    })
                                } else {
                                    if (geolib.getAreaOfPolygon(poligon) / 10000 > this.props.limiteHa) {
                                        this.props.notify({
                                            message: `${this.state.text["38"]} (${Math.round(this.props.limiteHa * 100) / 100} Ha)`,
                                            variant: 'error'
                                        })
                                    } else {
                                        this.props.setPolygon(poligon)

                                    }
                                }

                                setTimeout(() => this.setState({cargado: true}), 1)
                            }
                        }}
                    >
                        <ZoomControl
                            position={'topright'}
                        />
                        {this.props.mapa === 'satelite' && <TileLayer url={urls.satelite}/>}
                        {this.props.mapa === 'carreteras' && <TileLayer url={urls.carreteras}/>}

                        {/*{Object.keys(this.state.spain_geom).map(name =>*/}
                        {/*    <Polygon*/}
                        {/*        positions={this.state.spain_geom[name]}*/}
                        {/*        color={"#0082ff"}*/}
                        {/*        fillColor={"#0082ff"}*/}
                        {/*        fillOpacity={0}*/}
                        {/*        onclick={() => {*/}

                        {/*        }}*/}
                        {/*    />*/}
                        {/*)}*/}

                        {this.state.cargado && this.props.polygon.map((point: LatLngTuple, index) =>
                            <Marker
                                key={index}
                                draggable={this.state.clicked === "editar"}
                                position={point}
                                icon={this.setIcon()}
                                ondragend={e => {
                                    this.setState({cargado: false})
                                    let poligon = [...this.props.polygon] as LatLngTuple[]
                                    poligon[index] = [e.target.getLatLng().lat, e.target.getLatLng().lng] as LatLngTuple

                                    // if (this.pointInSpain([e.target.getLatLng().lat, e.target.getLatLng().lng] as LatLngTuple)) {
                                    //     if (geolib.getAreaOfPolygon(poligon)/10000 > 1000) {
                                    //         this.props.notify({message: this.state.text["40"], variant: 'error'})
                                    //     } else {
                                    //         if(geolib.getAreaOfPolygon(poligon)/10000 > this.props.limiteHa) {
                                    //             this.props.notify({message: `${this.state.text["40"]} (${Math.round(this.props.limiteHa*100)/100} Ha)`, variant: 'error'})
                                    //         } else {
                                    //             this.props.setPolygon(poligon)
                                    //
                                    //         }
                                    //     }
                                    // } else {
                                    //     this.props.notify({message: `${this.state.text["39"]}`, variant: 'error'})
                                    // }

                                    if (geolib.getAreaOfPolygon(poligon)/10000 > 1000) {
                                        this.props.notify({message: this.state.text["40"], variant: 'error'})
                                    } else {
                                        if(geolib.getAreaOfPolygon(poligon)/10000 > this.props.limiteHa) {
                                            this.props.notify({message: `${this.state.text["40"]} (${Math.round(this.props.limiteHa*100)/100} Ha)`, variant: 'error'})
                                        } else {
                                            this.props.setPolygon(poligon)

                                        }
                                    }

                                    setTimeout(() => this.setState({cargado: true}), 1)
                                }}
                            />
                        )}

                        {this.state.cargado &&
                        <Polygon
                            positions={this.props.polygon}
                            color={this.setColor() as string}
                            fillColor={this.setColor() as string}
                            fillOpacity={0.2}
                            onclick={() => {
                                if (this.state.clicked === "borrar") {
                                    this.props.setPolygon([] as LatLngTuple[])
                                    this.setState({clicked: ""})
                                }
                            }}
                        />
                        }

                    </Map>

                    <div
                        style={{
                            width: 150,
                            height: 150,
                            marginRight: 20,
                            marginLeft: -174,
                            marginBottom: 20,
                            backgroundColor: "transparent",
                            zIndex: 2,
                            borderRadius: 20,
                            borderStyle: "solid",
                            borderWidth:2,
                            borderColor: this.state.hover === 'sat'? 'rgba(0,0,0,0.8)' : 'rgba(0,0,0,0.2)',
                            alignSelf: "flex-end"
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                width: 150,
                                height:150,
                                borderRadius: 20,
                                backgroundColor: this.state.hover === 'sat'? 'rgba(240,240,240)' :
                                    this.props.mapa === 'satelite'? 'rgba(128,128,128)' : "white",
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                            onMouseEnter={() => this.setState({hover: 'sat'})}
                            onMouseLeave={() => this.setState({hover: ''})}
                            onClick={() => {this.handleVista()}}
                        >
                            <Map
                                center={this.props.center}
                                zoom={Math.floor(this.props.zoom/2)}
                                zoomControl={false}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    borderRadius: 20,
                                    cursor: "pointer"
                                }}
                            >
                                {this.props.mapa === 'carreteras' && <TileLayer url={urls.satelite}/>}
                                {this.props.mapa === 'satelite' && <TileLayer url={urls.carreteras}/>}
                            </Map>

                        </div>
                    </div>

                </div>
            </div>
        )
    }

}

const mapStateToProps = (state: IStore) => ({
    mapa: state.principal.mapa,
    zoom: state.principal.zoom,
    center: state.principal.center,
    polygon: state.crearParcela.polygon,
    limiteHa: state.crearParcela.limiteHa,
    level: state.navegacion.level,
    idioma: state.config.idioma
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    notify: (notification: INotificacion) => dispatch({type: 'notify', notification}),
    setMapa: (mapa: IMapas) => dispatch({type: "set-principal-mapa", mapa}),
    setZoom: (zoom: number) => dispatch({type: "set-principal-zoom", zoom}),
    setCenter: (center: LatLngTuple) => dispatch({type: "set-principal-center", center}),
    setPolygon: (polygon: LatLngTuple[]) => dispatch({type: "set-crear-parcela-polygon", polygon}),
    setEditando: (editando: boolean) => dispatch({type: "set-crear-parcela-editando", editando}),
    setCrearParcelaSection: (seccion: INewParcelaSection) => dispatch({type: "select-crear-parcela-seccion", seccion}),
    setHusoUTM: (huso: number) => dispatch({type:"set-crear-parcela-huso", huso}),
    setBandeUTM: (banda: string) => dispatch({type: "set-crear-parcela-banda", banda})
});

export default connect(mapStateToProps, mapDispatchToProps)(Ubicacion);
